<template>
    <v-overlay :value="overlay" :absolute=true :opacity=0.2>
        <v-card :color="mainColor" style="width:20rem; height:15rem">
            <v-card-text class="text-center">
                {{ $t("Overlay") }}
                <v-spacer></v-spacer>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-progress-circular indeterminate size="64" ></v-progress-circular>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-overlay>
</template>

<script>
import i18n from "../../../i18n";

export default {
    name: "custom-overlay",
    created() {
        this.mainColor = this.$vuetify.theme.themes.light.primary;
    },
    data() {
        return {
            mainColor: "",
        }
    },
    computed: {
        overlay() {
            return this.$store.state.overlay;
        },
    },
}
</script>
